// src/Router.jsx
// Top-level routing for public marketing pages.
// The main authenticated app (App.jsx) is mounted at "/*" and handles
// its own internal tab-based navigation unchanged.

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import { usePageViewTracking } from './hooks/useAnalytics';

function AnalyticsWrapper({ children }) {
  usePageViewTracking();
  return children;
}
import PricingPage from './pages/PricingPage';
import AboutPage from './pages/AboutPage';
import FAQPage from './pages/FAQPage';
import GeoRiskMapPage from './pages/features/GeoRiskMapPage';
import PortfolioOptimizerPage from './pages/features/PortfolioOptimizerPage';
import DCFModelPage from './pages/features/DCFModelPage';
import MonteCarloPage from './pages/features/MonteCarloPage';
import StockScreenerPage from './pages/features/StockScreenerPage';
import InsiderIntelligencePage from './pages/features/InsiderIntelligencePage';
import PortfolioBacktestingPage from './pages/features/PortfolioBacktestingPage';
import FixedIncomeTrackerPage from './pages/features/FixedIncomeTrackerPage';
import BloombergTerminalPage from './pages/vs/BloombergTerminalPage';

export default function Router() {
  return (
    <BrowserRouter>
      <AnalyticsWrapper>
      <Routes>
        {/* Public marketing / SEO pages */}
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/features/geo-risk-map" element={<GeoRiskMapPage />} />
        <Route path="/features/portfolio-optimizer" element={<PortfolioOptimizerPage />} />
        <Route path="/features/dcf-model" element={<DCFModelPage />} />
        <Route path="/features/monte-carlo-simulation" element={<MonteCarloPage />} />
        <Route path="/features/stock-screener" element={<StockScreenerPage />} />
        <Route path="/features/insider-intelligence" element={<InsiderIntelligencePage />} />
        <Route path="/features/portfolio-backtesting" element={<PortfolioBacktestingPage />} />
        <Route path="/features/fixed-income-tracker" element={<FixedIncomeTrackerPage />} />
        <Route path="/vs/bloomberg-terminal" element={<BloombergTerminalPage />} />

        <Route path="/about" element={<AboutPage />} />
        <Route path="/faq" element={<FAQPage />} />

        {/* Everything else — authenticated app with internal tab routing */}
        <Route path="/*" element={<App />} />
      </Routes>
      </AnalyticsWrapper>
    </BrowserRouter>
  );
}
